// RealGrid 공용 옵션·헬퍼 (거래명세서·세금계산서 화면)
import * as RealGrid from 'realgrid';

export const GRID_BASE: RealGrid.GridOptions = {
  stateBar: { visible: false },
  edit: { editable: false, readOnly: true },
  sorting: { enabled: true, showSortOrder: true, style: RealGrid.SortStyle.INCLUSIVE },
};

/** 그리드에서 체크된 행의 JSON 값들 */
export function checkedRows(grid: RealGrid.GridView): Record<string, unknown>[] {
  return grid.getCheckedRows().map(row => grid.getDataSource().getJsonRow(row) as Record<string, unknown>);
}
